/* ════ TASK MODAL ══════════════════════════════════════════ */
import { state } from '../state.js';
import { $, $$ } from '../dom.js';
import { sb } from '../supabase/client.js';
import { setSyncDot, logActivity } from '../supabase/data.js';
import { showToast } from '../utils/toast.js';
import { refreshSubtaskUI } from '../subtasks.js';
import { refreshTaskTags } from '../tagsedit.js';
import { fdate, addD, pdate, workingEnd } from '../utils/date.js';
import { canSeeTask } from '../privacy.js';

export function pickCat(el) { $$('#task-modal .cat-chip').forEach(c => c.classList.remove('sel')); el.classList.add('sel'); state.selCat = el.dataset.c; }

// Inclusive end for a `dur`-day task from `start`, honouring the skip-weekends mode.
const endOf = (start, dur) => state.skipWeekends ? workingEnd(start, dur) : addD(start, dur - 1);

// Earliest weekday start >= `from` where the resource's lane is free for `dur` days.
function nextFreeSlot(resId, dur, from) {
  const busy = state.tasks.filter(t => t.resource === resId)
    .map(t => ({ s: pdate(t.start), e: pdate(t.end) })).sort((a, b) => a.s - b.s);
  const skipWE = d => { while (d.getDay() === 0 || d.getDay() === 6) d.setDate(d.getDate() + 1); return d; };
  let start = skipWE(new Date(from));
  for (let i = 0; i < 800; i++) {
    const end = endOf(start, dur);
    const clash = busy.find(t => t.s <= end && t.e >= start);
    if (!clash) return start;
    start = skipWE(addD(clash.e, 1));
  }
  return start;
}
// Resource = the red10 person / planner lane.
function fillRes(sel) { $('f-res').innerHTML = state.resources.map(r => `<option value="${r.id}"${r.id === sel ? ' selected' : ''}>${r.name}</option>`).join(''); }

function setCatChip() {
  $$('#task-modal .cat-chip').forEach(c => c.classList.remove('sel'));
  document.querySelector(`#task-modal .cat-chip[data-c="${state.selCat}"]`)?.classList.add('sel');
}
// Reflect a half value into the two half-day selects.
function setHalf(half) {
  $('f-startpm').value = (half === 'pm' || half === 'pmam') ? '1' : '0';
  $('f-endam').value = (half === 'am' || half === 'pmam') ? '1' : '0';
}
// Combine the two selects into a single half value.
function readHalf() {
  const pm = $('f-startpm').value === '1', am = $('f-endam').value === '1';
  return pm && am ? 'pmam' : pm ? 'pm' : am ? 'am' : 'none';
}

export function openNew(start, end, resId, half = 'none') {
  state.editId = null; state.subtasks = [];
  $('m-title').textContent = 'New task';
  $('del-btn').style.display = 'none'; $('dup-btn').style.display = 'none';
  ['f-client', 'f-team', 'f-name', 'f-job', 'f-hours', 'f-cost', 'f-designer', 'f-consultant', 'f-info', 'f-link'].forEach(id => $(id).value = '');
  $('f-start').value = start || '';
  $('f-end').value = end || '';
  setHalf(half);
  $('f-imp').value = 'normal'; $('f-lock').checked = false; $('f-complete').checked = false; $('f-private').checked = false;
  $('f-ready').checked = false; $('f-invoiced').checked = false;
  $('f-author').textContent = state.currentUser?.email || '—';
  state.taskTags = []; refreshTaskTags();
  fillRes(resId || state.resources[1]?.id || '');
  state.selCat = 'output'; setCatChip();
  refreshSubtaskUI();
  $('task-modal').classList.add('open');
  setTimeout(() => $('f-name').focus(), 240);
}

// Create a planner task pre-filled from an Inbox idea (carries subtasks).
export function scheduleFromIdea(idea) {
  state.editId = null;
  state.subtasks = (idea.subtasks || []).map(s => ({ text: s.text, done: !!s.done }));
  $('m-title').textContent = 'Schedule from Inbox';
  $('del-btn').style.display = 'none'; $('dup-btn').style.display = 'none';
  $('f-name').value = idea.name || '';
  $('f-client').value = ''; $('f-team').value = ''; $('f-job').value = ''; $('f-hours').value = ''; $('f-cost').value = ''; $('f-designer').value = ''; $('f-consultant').value = ''; $('f-link').value = '';
  $('f-info').value = idea.description || '';
  const today = new Date(); today.setHours(0, 0, 0, 0);
  const days = Math.max(1, Math.round(idea.days || 1));
  const resId = idea.resource || state.resources[1]?.id || state.resources[0]?.id || '';
  // Suggest the next free slot in the assigned resource's lane.
  const start = nextFreeSlot(resId, days, today);
  $('f-start').value = fdate(start);
  $('f-end').value = fdate(endOf(start, days));
  setHalf('none');
  $('f-imp').value = idea.importance || 'normal'; $('f-lock').checked = false; $('f-complete').checked = false; $('f-private').checked = false;
  $('f-ready').checked = false; $('f-invoiced').checked = false;
  $('f-author').textContent = state.currentUser?.email || '—';
  state.taskTags = [...(idea.tags || [])]; refreshTaskTags();
  fillRes(resId);
  state.selCat = idea.cat || 'output'; setCatChip();
  refreshSubtaskUI();
  $('task-modal').classList.add('open');
  setTimeout(() => $('f-name').focus(), 240);
  const human = start.toLocaleDateString(undefined, { day: 'numeric', month: 'short' });
  showToast(`Suggested next free slot: ${human}`);
}

export function openEdit(id) {
  // Match loosely: the List view passes a string dataset id, but task ids may be
  // numeric — a strict === would miss and silently fail to open.
  const t = state.tasks.find(x => String(x.id) === String(id)); if (!t) return;
  if (!canSeeTask(t)) { showToast('🔒 This task is private'); return; }
  state.editId = id; state.subtasks = [...(t.subtasks || [])];
  $('m-title').textContent = 'Edit task';
  $('del-btn').style.display = 'inline-flex'; $('dup-btn').style.display = 'inline-flex';
  $('f-name').value = t.name;
  $('f-client').value = t.client || '';
  $('f-team').value = t.team || '';
  $('f-start').value = t.start;
  $('f-end').value = t.end;
  $('f-job').value = t.job || '';
  $('f-hours').value = t.hours ?? '';
  $('f-cost').value = t.cost ?? '';
  $('f-designer').value = t.designer || '';
  $('f-consultant').value = t.consultant || '';
  $('f-info').value = t.info || '';
  $('f-link').value = t.link || '';
  setHalf(t.half || 'none');
  $('f-imp').value = t.importance || 'normal'; $('f-lock').checked = !!t.locked; $('f-complete').checked = !!t.completed; $('f-private').checked = !!t.private;
  $('f-ready').checked = !!t.ready_invoice; $('f-invoiced').checked = !!t.invoiced;
  $('f-author').textContent = t.created_by || '—';
  state.taskTags = [...(t.tags || [])]; refreshTaskTags();
  fillRes(t.resource);
  state.selCat = t.cat || 'output'; setCatChip();
  refreshSubtaskUI();
  $('task-modal').classList.add('open');
}

export function closeModal() { $('task-modal').classList.remove('open'); state.editId = null; }

export async function saveTask() {
  const name = $('f-name').value.trim(); if (!name) { showToast('Please enter a task name'); return; }
  const start = $('f-start').value, end = $('f-end').value;
  if (!start || !end) { showToast('Please enter dates'); return; }
  if (end < start) { showToast('End must be after start'); return; }
  const data = {
    name, client: $('f-client').value, team: $('f-team').value, start, end, cat: state.selCat, half: readHalf(),
    resource: $('f-res').value, job: $('f-job').value,
    hours: parseFloat($('f-hours').value) || null,
    cost: parseFloat($('f-cost').value) || null,
    designer: $('f-designer').value, consultant: $('f-consultant').value,
    info: $('f-info').value, link: $('f-link').value, importance: $('f-imp').value,
    locked: $('f-lock').checked, completed: $('f-complete').checked, private: $('f-private').checked,
    ready_invoice: $('f-ready').checked, invoiced: $('f-invoiced').checked, tags: state.taskTags, subtasks: state.subtasks,
    updated_at: new Date().toISOString(),
  };
  setSyncDot('busy'); let error;
  if (state.editId) { ({ error } = await sb.from('tasks').update(data).eq('id', state.editId)); }
  else { data.created_by = state.currentUser?.email || null; ({ error } = await sb.from('tasks').insert(data)); }
  if (error) { setSyncDot('err'); showToast('Save failed: ' + error.message); return; }
  setSyncDot('ok'); showToast(state.editId ? 'Task updated ✓' : 'Task created ✓');
  logActivity(state.editId ? 'updated' : 'created', 'task', name);
  closeModal();
}

// Duplicate the task currently shown (using the on-screen values).
export async function duplicateTask() {
  const name = $('f-name').value.trim(); if (!name) { showToast('Nothing to duplicate'); return; }
  const start = $('f-start').value, end = $('f-end').value;
  if (!start || !end) { showToast('Please enter dates'); return; }
  const data = {
    name: name + ' (copy)', client: $('f-client').value, team: $('f-team').value, start, end, cat: state.selCat, half: readHalf(),
    resource: $('f-res').value, job: $('f-job').value,
    hours: parseFloat($('f-hours').value) || null,
    cost: parseFloat($('f-cost').value) || null,
    designer: $('f-designer').value, consultant: $('f-consultant').value,
    info: $('f-info').value, link: $('f-link').value, importance: $('f-imp').value,
    locked: $('f-lock').checked, completed: $('f-complete').checked, private: $('f-private').checked,
    ready_invoice: $('f-ready').checked, invoiced: $('f-invoiced').checked, tags: [...state.taskTags],
    subtasks: state.subtasks.map(s => ({ text: s.text, done: !!s.done })),
    created_by: state.currentUser?.email || null,
  };
  setSyncDot('busy');
  const { error } = await sb.from('tasks').insert(data);
  if (error) { setSyncDot('err'); showToast('Duplicate failed: ' + error.message); return; }
  setSyncDot('ok'); showToast('Task duplicated ✓'); logActivity('duplicated', 'task', data.name); closeModal();
}

export async function deleteTask() {
  if (state.editId === null || !confirm('Delete this task?')) return;
  setSyncDot('busy'); const { error } = await sb.from('tasks').delete().eq('id', state.editId);
  if (error) { setSyncDot('err'); showToast('Delete failed: ' + error.message); return; }
  setSyncDot('ok'); showToast('Task deleted'); closeModal();
}
